import React from 'react';
import { Input as TPAInput, type InputProps as TPAInputProps } from '@wix/wix-ui-tpa';
import { type DeviceTypeEnum } from '../../../../types/DeviceType';
import * as styleSheet from './styles.st.css';

interface InputProps {
  appearance: DeviceTypeEnum;
}

export const Input = (props: InputProps & TPAInputProps) => {
  const { appearance, ...restProps } = props;

  return (
    <TPAInput
      {...restProps}
      className={styleSheet.st(styleSheet.classes.root, {
        mobile: props.appearance === 'mobile',
        invalid: !!props.error,
      })}
      {...{
        // TODO: Move to wix-ui-tpa
        'aria-required': !!props.required,
      }}
    />
  );
};

Input.displayName = 'Input';
